let lastArtificialId = 0;

export const isArtificialId = id => id < 0;

export default function getId() {
  lastArtificialId -= 1;
  return lastArtificialId;
}
